import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Components
import Navbar from './navbar/Navbar';
import Loader from './loader/Loader';
import SettingsSidebar from './sidebar/SettingsSidebar';

// Action imports
import { updateProfile, getUser } from '../actions/auth';

// CSS
import '../css/landing/landing.css';
import '../css/profile/yourProfile.css';

const YourProfile = ({
  auth: { isAuthenticated, user },
  getUser,
  updateProfile,
}) => {
  const [paidButton, setPaidButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // States
  const [profileData, setProfiledata] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile_number: '',
  });

  // Destructure Form Data
  const { name, email, mobile_number } = formData;

  // Load user data
  useEffect(() => {
    // Call user API to get his data
    getUser().then((res) => {
      // console.log('user Data', res);
      // setUserdata(res.data);
      setFormData({
        ...formData,
        name: res.data.user_name,
        email: res.data.user_email,
        mobile_number: res.data.user_mobile_number,
      });
      console.log('user data', res.data);
      setProfiledata(true);
    });
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    toast.info('Saving Changes...');
    updateProfile({ name })
      .then((res) => {
        // setLoading(false);
        // console.log('API return', res);
        if (res.status === 200) {
          toast.success('Profile Updated Successfully');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();

        // Save the IP address in local storage
        localStorage.setItem('userIp', data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    // Check if the user's IP address is already saved in local storage
    const savedUserIp = localStorage.getItem('userIp');
    if (!savedUserIp) {
      fetchIpAddress();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      setIsLoading(true);
      // console.log('user Authenticated');
      // console.log('user', user);

      if (user.is_paid) {
        // console.log('paid User', user.is_paid);
        setPaidButton(true);
        setIsLoading(false);
      } else {
        // console.log('no is_paid user');
        setIsLoading(false);
      }
    }
  }, [isAuthenticated, user]);

  const onChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const onChangeMobile = (e) => {
    const { value } = e.target;

    // Check if the entered value is numeric
    if (/^\d*$/.test(value) || value === '') {
      setFormData({
        ...formData,
        mobile: value,
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <SettingsSidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <div className=''>
              <Navbar />
            </div>

            {/* Main Content */}
            <div className='profile-page-wrapper flex-1 bg-white p-6'>
              {/* Heading and Horizontal Line */}
              <h1 className='your-profile-page-heading'>Your Profile</h1>
              <hr />

              {/* Profile Form */}
              <form
                onSubmit={(e) => onSubmit(e)}
                method='POST'
                className='space-y-7 your-profile-form'
              >
                {/* Name Input */}
                <div>
                  <label htmlFor='name' className='your-profile-form-label'>
                    Name
                  </label>
                  <input
                    type='text'
                    id='name'
                    name='name'
                    value={name}
                    onChange={(e) => onChange(e)}
                    autoComplete='name'
                    required
                    maxLength='40'
                    placeholder='Full Name'
                    className='form-input-field w-full p-2'
                  />
                </div>

                {/* Email Address Input */}
                <div>
                  <label htmlFor='email' className='your-profile-form-label'>
                    Email Address
                  </label>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    value={email}
                    onChange={(e) => onChange(e)}
                    autoComplete='email'
                    required
                    placeholder='Email'
                    className='form-input-field bg-gray-50 w-full p-2'
                    disabled
                  />
                </div>

                {/* Phone Number Input */}
                <div>
                  <label htmlFor='phone' className='your-profile-form-label'>
                    Phone Number
                  </label>
                  <input
                    id='mobile'
                    name='mobile'
                    type='tel'
                    value={mobile_number}
                    onChange={onChangeMobile}
                    autoComplete='current-mobile'
                    pattern='[0-9]{10}'
                    title='Please enter a 10-digit numeric mobile number.'
                    inputMode='numeric'
                    minLength={10}
                    maxLength={10}
                    required
                    placeholder='Mobile Number'
                    className='form-input-field w-full bg-gray-50 p-2'
                    disabled
                  />
                </div>

                {/* Save Button */}
                <div>
                  <button type='submit' className='form-button py-1 px-3'>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { getUser, updateProfile })(
  YourProfile
);
